/** @jsxImportSource @emotion/react */
import { memo } from "react";
import { ErrorParts } from "screens/Error";

/**
 * ErrorFallback
 */
const ErrorFallback = memo(({ error }) => {
  console.log(error);
  return <ErrorParts errorCode={500}></ErrorParts>;
});

export default ErrorFallback;
